import { render, staticRenderFns } from "./ProductFormArchEmbeddable.vue?vue&type=template&id=cec8ea38&"
import script from "./ProductFormArchEmbeddable.vue?vue&type=script&lang=js&"
export * from "./ProductFormArchEmbeddable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports